<template>
  <HeadlineComponent
    >Aufgabe "{{ task.name }}" in Team "{{ team.name }}"
    bearbeiten</HeadlineComponent
  >
  <Form
    class="form-horizontal"
    @submit="save"
    :initialValues="task"
    v-slot="{ values }"
    v-if="loaded"
  >
    <TaskForm :values="values" :startDate="team.start_date"></TaskForm>
    <LoadingButton class="btn-primary" :loading="loading"
      >Speichern</LoadingButton
    >
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "../stores/alerts.js";
import teamService from "../services/team.service.js";
import taskService from "../services/task.service.js";
import TaskForm from "@/components/TaskForm.vue";
import { Form } from "vee-validate";
import moment from "moment";
import { setErrors } from "@/helper/ErrorToActions.js";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateTaskView",
  data() {
    return {
      team: {},
      name: "",
      task: {},
      loaded: false,
      loading: false,
    };
  },
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Form, TaskForm, LoadingButton, HeadlineComponent },
  async beforeMount() {
    if (this.$route.params.task) {
      try {
        let response = await taskService.get(
          this.$route.params.event,
          this.$route.params.team,
          this.$route.params.task
        );
        this.name = response.data.name;
        this.task = response.data;
        for (let shift of response.data.shifts) {
          shift.start = moment(shift.start).format("YYYY-MM-DDTHH:mm");
          shift.end = moment(shift.end).format("YYYY-MM-DDTHH:mm");
        }
      } catch (e) {
        if (e.response && e.response.data) {
          this.addAlert("danger", e.response.data.message);
        } else {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          console.log(e);
        }
      }
    }
    try {
      let response = await teamService.get(
        this.$route.params.event,
        this.$route.params.team
      );
      this.team = response.data;
      this.team.start_date = moment(this.team.start_date).format(
        "YYYY-MM-DDTHH:mm"
      );
    } catch (e) {
      if (e.response && e.response.data) {
        this.addAlert("danger", e.response.data.message);
      } else {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        console.log(e);
      }
    }
    this.loaded = true;
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async save(form, actions) {
      this.loading = true;
      for (let shift of form.shifts) {
        if (!shift.start || !shift.end) {
          this.addAlert(
            "danger",
            "Alle Schichten brauchen gültige Start und Endzeiten."
          );
          return;
        }
      }
      try {
        let data = {
          name: form.name,
          description: form.description,
          shifts: [],
          locked: form.locked,
          ticket_relevant: form.ticket_relevant,
        };
        for (let shift of form.shifts) {
          var start = moment(shift.start, "YYYY-MM-DDTHH:mm");
          var end = moment(shift.end, "YYYY-MM-DDTHH:mm");

          if (!start.isValid() || !end.isValid()) {
            this.addAlert(
              "danger",
              "Alle Schichten brauchen gültige Start und Endzeiten."
            );
            return;
          }
          var s = JSON.parse(JSON.stringify(shift));
          s.start = start.format();
          s.end = end.format();
          s.ticket_relevant = form.ticket_relevant;
          data.shifts.push(s);
        }
        await taskService.update(
          this.$route.params.event,
          this.$route.params.team,
          this.task.id,
          data
        );
        this.addAlert("success", "Aufgabe erfolgreich bearbeitet");
        this.$router.push({
          path: "/teams",
          query: { event_id: this.$route.params.event },
        });
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
